export const HEADING_FONT = `BiankaScript, cursive;`;
export const HEADING_ALTERNATIVE = `'Pinyon Script', cursive;`;
export const BODY_FONT = `'Montserrat', sans-serif;`;
export const BODY_ALTERNATIVE = `'Montserrat', sans-serif;`;
